import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Building2 } from "lucide-react";
import { useLanguage } from "@/i18n";
import Logo from "@/components/Logo";

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer data-testid="main-footer-container" className="border-t border-white/10 bg-[#070A10]">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2.5">
              <Logo className="h-8 w-8" />
              <span className="text-lg font-extrabold text-white" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>
                iTranspro
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">{t.footer.desc}</p>
            <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-cyan-400/80">{t.common.guarantee}</p>
          </div>
          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-white">{t.footer.navTitle}</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link data-testid="footer-home-link" to="/" className="text-slate-400 transition-colors hover:text-cyan-300">{t.nav.home}</Link></li>
              <li><Link data-testid="footer-it-link" to="/it" className="text-slate-400 transition-colors hover:text-cyan-300">{t.nav.it}</Link></li>
              <li><Link data-testid="footer-transport-link" to="/transport" className="text-slate-400 transition-colors hover:text-cyan-300">{t.nav.transport}</Link></li>
              <li><Link data-testid="footer-contact-link" to="/contact" className="text-slate-400 transition-colors hover:text-cyan-300">{t.nav.contact}</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-white">{t.footer.contactTitle}</h3>
            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              <li className="flex items-center gap-2.5"><MapPin className="h-4 w-4 text-cyan-400" /> {t.contact.addr1}</li>
              <li className="flex items-center gap-2.5"><Building2 className="h-4 w-4 text-cyan-400" /> {t.contact.ide}</li>
              <li className="flex items-center gap-2.5"><Mail className="h-4 w-4 text-cyan-400" /> {t.contact.emailLabel}</li>
              <li className="flex items-center gap-2.5"><Phone className="h-4 w-4 text-cyan-400" /> {t.contact.phoneLabel}</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 sm:flex-row">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} iTranspro Sàrl — {t.contact.ide}. {t.footer.rights}</p>
          <div className="flex items-center gap-5">
            <Link data-testid="footer-legal-link" to="/mentions-legales" className="text-xs text-slate-500 transition-colors hover:text-cyan-300">{t.footer.legal}</Link>
            <Link data-testid="footer-privacy-link" to="/confidentialite" className="text-xs text-slate-500 transition-colors hover:text-cyan-300">{t.footer.privacy}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
